<div class="main-content pick-board-shell">
<div class="pick-board" #boardRoot [class.is-fullscreen]="fullscreen">

	<!-- ── Marquee: who we are, what time it is, what's next out the door ── -->
	<header class="board-top">
		<div class="board-id">
			<div class="board-title">PICK BOARD</div>
			<div class="board-loc">{{ locationName || 'Warehouse' }}</div>
		</div>

		<div class="board-clock">
			<div class="clock-time">{{ now | date:'HH:mm' }}<span class="secs">:{{ now | date:'ss' }}</span></div>
			<div class="clock-date">{{ now | date:'EEEE, MMM d' }}</div>
		</div>

		<div class="board-cutoffs">
			<div class="cutoff" *ngFor="let c of cutoffs" [ngClass]="cutoffTone(c)">
				<div class="cut-label">{{ c.label }}</div>
				<div class="cut-count">{{ countdown(c) }}</div>
				<div class="cut-meta">
					<span class="cut-time">{{ c.time }}</span>
					<span class="cut-load" *ngIf="c.orders">· {{ c.orders }} open</span>
				</div>
			</div>
			<div class="cutoff ok" *ngIf="!cutoffs.length">
				<div class="cut-label">No cutoffs set</div>
				<div class="cut-count">—</div>
			</div>
		</div>

		<div class="board-chrome">
			<span class="live-dot" [class.on]="live" [title]="live ? 'Live' : 'Polling'"></span>
			<span class="updated" *ngIf="lastUpdated">{{ lastUpdated | date:'HH:mm:ss' }}</span>
			<button type="button" class="chrome-btn" (click)="load()" aria-label="Refresh board">
				<i class="material-icons">refresh</i>
			</button>
			<button type="button" class="chrome-btn" (click)="toggleFullscreen()" aria-label="Toggle fullscreen">
				<i class="material-icons">{{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}</i>
			</button>
		</div>
	</header>

	<!-- ── Floor at a glance ── -->
	<section class="board-stats">
		<div class="stat">
			<div class="stat-val">{{ stats.to_pick }}</div>
			<div class="stat-lbl">To Pick</div>
		</div>
		<div class="stat is-progress">
			<div class="stat-val">{{ stats.in_progress }}</div>
			<div class="stat-lbl">In Progress</div>
		</div>
		<div class="stat is-ready">
			<div class="stat-val">{{ stats.ready }}</div>
			<div class="stat-lbl">Ready</div>
		</div>
		<div class="stat is-late" [class.zero]="!stats.late">
			<div class="stat-val">{{ stats.late }}</div>
			<div class="stat-lbl">Late</div>
		</div>
		<div class="stat is-short" [class.zero]="!stats.short">
			<div class="stat-val">{{ stats.short }}</div>
			<div class="stat-lbl">Short</div>
		</div>
		<div class="stat">
			<div class="stat-val">{{ stats.lines_done }}<span class="of">/{{ stats.lines }}</span></div>
			<div class="stat-lbl">Lines</div>
		</div>
		<div class="stat">
			<div class="stat-val">{{ stats.units_picked | number:'1.0-0' }}<span class="of">/{{ stats.units | number:'1.0-0' }}</span></div>
			<div class="stat-lbl">Units</div>
		</div>
		<div class="stat is-people">
			<div class="stat-val">{{ stats.pickers }}</div>
			<div class="stat-lbl">Pickers</div>
		</div>
	</section>

	<div class="board-error" *ngIf="error">
		<i class="material-icons">error</i> {{ error }}
	</div>

	<div class="board-loading" *ngIf="loading && !orders.length && !error">
		<mat-progress-spinner mode="indeterminate" diameter="48" color="accent"></mat-progress-spinner>
	</div>

	<!-- ── The queue. Rank 1 is the next order off the floor. ── -->
	<section class="board-body" *ngIf="!loading || orders.length">
		<div class="queue">
			<div class="queue-head">
				<span class="qh-title">Pick Next</span>
				<span class="qh-page" *ngIf="pageCount > 1">{{ page + 1 }} / {{ pageCount }}</span>
			</div>

			<article class="qrow" *ngFor="let o of pagedOrders; let i = index; trackBy: trackByOrderno"
				[ngClass]="rowTone(o)" (click)="openOrder(o)">
				<div class="rank">{{ rankOf(i) }}</div>

				<div class="qmain">
					<div class="qline1">
						<span class="ordno">#{{ o.orderno }}</span>
						<span class="cust">{{ o.customer }}</span>
						<span class="flag late" *ngIf="o.late">LATE</span>
						<span class="flag asap" *ngIf="o.asap && !o.late">ASAP</span>
						<span class="flag short" *ngIf="o.short_lines > 0">SHORT {{ o.short_lines }}</span>
						<span class="flag picker" *ngIf="o.claimed_user">
							<i class="material-icons">person</i>{{ o.claimed_user }}
						</span>
					</div>
					<div class="qline2">
						<span class="chip" *ngIf="o.city">{{ o.city }}</span>
						<span class="chip" *ngIf="o.shipvia">{{ o.shipvia }}</span>
						<span class="chip bins" *ngIf="o.bin_range">
							<i class="material-icons">grid_view</i>{{ o.bin_range }}
						</span>
						<span class="chip">{{ o.line_count }} {{ o.line_count === 1 ? 'line' : 'lines' }}</span>
						<span class="chip">{{ o.qty_pick | number:'1.0-0' }} units</span>
						<span class="chip age">{{ age(o) }} old</span>
					</div>
				</div>

				<div class="qprog">
					<div class="prog-nums">{{ o.lines_done }}<span class="of">/{{ o.line_count }}</span></div>
					<div class="bar"><div class="fill" [style.width.%]="o.pct"></div></div>
				</div>

				<div class="qcut">
					<div class="cut-val">{{ orderCountdown(o) }}</div>
					<div class="cut-lbl">{{ o.cutoff_label || 'no cutoff' }}</div>
				</div>
			</article>

			<div class="queue-empty" *ngIf="!orders.length && !error">
				<i class="material-icons">check_circle</i>
				<span>Floor is clear — nothing waiting to be picked.</span>
			</div>
		</div>

		<!-- Staged work: picked, waiting on load-out. -->
		<aside class="rail">
			<div class="rail-head">
				<span>Picked &amp; Staged</span>
				<span class="rail-count">{{ ready.length }}</span>
			</div>
			<div class="rail-list">
				<div class="rrow" *ngFor="let o of ready; trackBy: trackByOrderno" (click)="openOrder(o)">
					<span class="rord">#{{ o.orderno }}</span>
					<span class="rcust">{{ o.customer }}</span>
					<span class="rqty">{{ o.qty_picked | number:'1.0-0' }}</span>
				</div>
				<div class="rail-empty" *ngIf="!ready.length">Nothing staged yet.</div>
			</div>

			<div class="rail-note" *ngIf="stats.held">
				<i class="material-icons">block</i>
				{{ stats.held }} order{{ stats.held === 1 ? '' : 's' }} on hold — not pickable
			</div>
		</aside>
	</section>

</div>
</div>
